import { Checkbox } from "@/components/elements/Checkbox";
import { useFormField } from "@/components/elements/FormField";
import { Stack } from "@mui/material";
import { ChangeEvent, FC, Key, useEffect, useState } from "react";

export type TCheckboxOption = {
  value: Key;
  label: string;
  subLabel?: string;
};

type TCheckboxGroupProps = {
  options: TCheckboxOption[];
  nonControl?: boolean;
  value?: Key[];
  enableOrderNumber?: boolean;
  onChange?: (value: Key[]) => void;
};

export const CheckboxGroup: FC<TCheckboxGroupProps> = ({ options, nonControl = false, value, enableOrderNumber = false, onChange }) => {
  const [checkedValues, setCheckedValues] = useState<Key[]>([]);
  const { field } = useFormField(nonControl);

  useEffect(() => {
    setCheckedValues(field?.value ?? value ?? []);
  }, [field?.value, value]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target;
    let newValues = [...checkedValues];
    if (checked) {
      newValues = [...newValues, value];
    } else {
      newValues = newValues.filter((v) => v !== value);
    }
    setCheckedValues(newValues);
    onChange?.(newValues);
    field?.onChange(newValues);
    field?.onBlur();
  };

  return (
    <Stack gap={1}>
      {options.map(({ label, subLabel, value }, index) => {
        return (
          <Checkbox
            key={index}
            label={label}
            prefixLabel={enableOrderNumber ? `${index + 1}.` : null}
            subLabel={subLabel}
            value={value}
            checked={checkedValues.includes(value.toString())}
            onChange={handleChange}
            nonControl
          />
        );
      })}
    </Stack>
  );
};
